
  window.addEventListener('load', function () {
    const isMobile = window.innerWidth < 768;
    const videos = document.querySelectorAll('.lazy-video');

    videos.forEach(video => {
      const isMobileVideo = video.classList.contains('mobile-video-url');
      const isDesktopVideo = video.classList.contains('desktop-video-url');

      // Only load the appropriate video for the device
      if ((isMobile && isMobileVideo) || (!isMobile && isDesktopVideo)) {
        const src = video.getAttribute('data-src');
        if (src) {
          video.src = src;
          video.style.display = 'block';

          const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                video.play().catch(() => {});
                observer.unobserve(video);
              }
            });
          }, {
            rootMargin: "0px 0px 200px 0px"
          });

          observer.observe(video);
        }
      }
    });
  });
